// Month of reference of every finance record, e.g. "2026-09"
export type Month = string;

export type FinanceGroup = 'INCOME' | 'BILL' | 'EXPENSE' | 'CARD';

export const FINANCE_GROUPS: { value: FinanceGroup, label: string }[] = [
  { value: 'INCOME', label: 'Incomes' },
  { value: 'BILL', label: 'Bills' },
  { value: 'EXPENSE', label: 'Expenses' },
  { value: 'CARD', label: 'Credit card' }
];

export interface CategoryModel {
  id: string,
  name: string,
  group: FinanceGroup,
  active: boolean
}

// Incomes, Bills and Expenses share the same shape
export interface EntryModel {
  id: string,
  month: Month,
  description: string,
  category: string,
  value: number
}

export interface CardModel {
  id: string,
  name: string,
  closingDay: number | null,
  dueDay: number | null,
  active: boolean
}

export interface CardItemModel {
  id: string,
  month: Month,
  card: string,
  description: string,
  category: string,
  value: number,
  installment: number | null,
  installments: number | null,
  // Purchase date as printed in the statement, e.g. "05/09"
  date?: string,
  // CardStatements record the item was read from
  statement?: string
}

export interface CardStatementModel {
  id: string,
  month: Month,
  card: string,
  name: string,
  // Not "path": withCurrentOwner drops fields named id, ref and path
  storagePath: string
}

// Route data of the generic entries screen
export interface EntriesConfig {
  title: string,
  collection: 'Incomes' | 'Bills' | 'Expenses',
  group: FinanceGroup,
  copyPrevious: boolean
}

// Categories of the spreadsheet used as a starting point
export const DEFAULT_CATEGORIES: { name: string, group: FinanceGroup }[] = [
  ...['Salário', 'Pró-labore', 'Aluguel', 'Dividendos', 'Outros'].map(name => ({ name, group: 'INCOME' as FinanceGroup })),
  ...['Moradia', 'Impostos', 'Telefone', 'Energia', 'Água', 'Saúde', 'Outros'].map(name => ({ name, group: 'BILL' as FinanceGroup })),
  ...['Diversão', 'Casa', 'Família', 'Carro', 'Férias', 'Outros'].map(name => ({ name, group: 'EXPENSE' as FinanceGroup })),
  ...['Parcelado', 'Fixo', 'Mercado', 'Casa', 'Delivery', 'Farmácia', 'Trabalho', 'Carro'].map(name => ({ name, group: 'CARD' as FinanceGroup }))
];
